import { useEffect, useState } from "react";
import { fetchExchangeRates, downloadExchangeRatesExcel } from "../Api/ViewExchangeRates";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewExchangeRates = () => {
  const [exchangeRates, setExchangeRates] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadExchangeRates = async () => {
      try {
        const data = await fetchExchangeRates();
        setExchangeRates(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Exchange Rates`);
      }
    };

    loadExchangeRates();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadExchangeRatesExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'ExchangeRates_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Exchange rates data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="list-title">View Exchange Rates</h2>
              <Button 
                className="generate-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || exchangeRates.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {exchangeRates.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Exchange Rate ID</th>
                    <th>From Currency</th>
                    <th>To Currency</th>
                    <th>Exchange Rate Type</th>
                    <th>Valid From</th>
                    <th>Rate</th>
                    <th>Currency Unit</th>
                    <th>Created On</th>
                    <th>Created By</th>
                    <th>Changed On</th>
                    <th>Changed By</th>
                  </tr>
                </thead>
                <tbody>
                  {exchangeRates.map((rate, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{rate.exchangeRateID}</td>
                      <td>{rate.fromCurrency}</td>
                      <td>{rate.toCurrency}</td>
                      <td>{rate.exchangeRateType}</td>
                      <td>{moment(rate.validFrom).format('L')}</td>
                      <td>{rate.rate}</td>
                      <td>{rate.currencyUnit}</td>
                      <td>
                        {moment(rate.createdOnDate).format('L')} at {rate.createdOnTime?.substring(0, 8)}
                      </td>
                      <td>{rate.createdBy}</td>
                      <td>
                        {rate.changedOnDate ? 
                          `${moment(rate.changedOnDate).format('L')} at ${rate.changedOnTime?.substring(0, 8)}` 
                          : '-'}
                      </td>
                      <td>{rate.changedBy || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No exchange rates found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewExchangeRates;